export default __webpack_public_path__ + "images/multilang-intro-step-3_2x.615f37c94202eb440c72b45237114c19.png";